import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject, NgModule } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';

export interface LoadingDialogData {
  message: string;
  icon: string;
}

@Component({
    selector: 'ts-loading-dialog',
    templateUrl: './loading-dialog.component.html',
    styleUrls: ['./loading-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class LoadingDialogComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public readonly data: Readonly<LoadingDialogData>) { }
}

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
  ],
  declarations: [LoadingDialogComponent],
  exports: [LoadingDialogComponent],
})
export class LoadingDialogComponentModule { }
